/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { StatusBadge, type StatusBadgeConfig } from '@g17eco/molecules/badge/StatusBadge';
import type { SectionType } from '@g17eco/types/insights-synthesis';

interface SectionTypeBadgeProps {
  sectionType: SectionType | undefined;
}

const sectionConfig: Record<SectionType, StatusBadgeConfig> = {
  environment: { color: 'success', icon: 'fa-leaf', label: 'Environment' },
  social: { color: 'primary', icon: 'fa-users', label: 'Social' },
  governance: { color: 'info', icon: 'fa-building', label: 'Governance' },
  economic: { color: 'warning', icon: 'fa-chart-line', label: 'Economic' },
};

const defaultConfig: StatusBadgeConfig = {
  color: 'light',
  icon: 'fa-th-large',
  label: 'All Sections',
};

export const SectionTypeBadge = ({ sectionType }: SectionTypeBadgeProps) => {
  const config = sectionType ? sectionConfig[sectionType] : defaultConfig;

  return <StatusBadge config={config} minWidth={95} />;
};
